<template>
  <div
    class="mx-4 mb-2"
    data-qa="block-budget">
    <div class="h9-label">
      {{ $t('Tenders.Budget') }}
    </div>
    <div
      v-if="!currConidtion"
      class="font-size-14"
      data-qa="info-bar-tender-budjet">
      <div v-if="!tender.biddingType || tender.biddingType.tenderingForPercentage">
        -
      </div>
      <template v-else>
        <div>{{ tender_budjet | formSum }} {{ tender.currency ? tender.currency.title : '' }}</div>
        <div>{{ tender.vatInclude ? $t('Tenders.WithVAT') : $t('Tenders.WithoutVAT') }}</div>
      </template>
    </div>
    <div v-else-if="currConidtion && tender.biddingType.allowedCurrenciesSelectionByOrganizer">
      <span class="font-size-14">{{ $t('Tenders.CcurrencyChosenByParticipant') }}</span>
      <ul>
        <li
          v-for="(currencyItem, index) in allowedCurrencies"
          :key="index"
          class="font-size-14">
          {{ currencyItem.title }}
        </li>
      </ul>
    </div>
    <div
      v-else
      class="font-size-14">
      – {{ $t('Tenders.CcurrencyChosenByParticipant') }}
    </div>
  </div>
</template>
<script>
import { modalMixin } from 'mixins'

export default {
  name: 'budgetInfo',
  mixins: [ modalMixin ],
  computed: {
    allowedCurrencies() {
      const result = this.tender?.allowedCurrencies || []
      if (!result?.length) {
        return []
      }
      const sprCurrencies = this.$store.getters.getCurrencies
      return result.map(allowedCurrency => {
        const sprCurrency = sprCurrencies.find(i => i.designation === allowedCurrency)
        return sprCurrency
          ? sprCurrency
          : {
            designation: allowedCurrency,
            title: allowedCurrency,
            shortTitle: allowedCurrency
          }
      })
        .sort((a,b) => a?.title?.localeCompare(b?.title))
    },
    currConidtion() {
      return this.tender.currencyOwner || (this.tender.bids && this.tender.bids.some(el => el.bidDetails.some(det => det.currencyId != this.tender.currency?.code)))
    },
    tender_budjet() {
      if (!this.tender || !this.tender.lots || !this.tender.lots.length) { return 0 }
      return this.tender.lots.reduce( (total, lot ) => {
        return total += lot.quantity * (lot.initialAmount ? lot.initialAmount : lot.startAmount) || 0
      }, 0)
    },
  },
  watch: {
    tender: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue?.biddingType?.allowedCurrenciesSelectionByOrganizer) {
          this.$store.dispatch('setCurrencies')
        }
      }
    }
  },
  props: {
    tender: {
      type: Object
    }
  },
}
</script>
